"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var StickyHeader_1 = __importDefault(require("./StickyHeader"));
var FloatingCTA_1 = __importDefault(require("./FloatingCTA"));
var CDFrame = /** @class */ (function (_super) {
    __extends(CDFrame, _super);
    function CDFrame() {
        var _this = _super.call(this, constants_1.DATA_CD_FRAME) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.cdFrame = _this.getElement();
        _this.footer = document.querySelector("[".concat(constants_1.DATA_FOOTER, "]"));
        _this.windowHeight = window.innerHeight;
        _this.initEventListeners();
        return _this;
    }
    CDFrame.prototype.initEventListeners = function () {
        this.onLoad();
        this.documentScroll();
        this.handleWindowHeightResize();
    };
    /**
     * Check if Footer is in Viewport onLoad
     */
    CDFrame.prototype.onLoad = function () {
        if (this.footer.getBoundingClientRect().top > this.windowHeight)
            return;
        this.cdFrame.classList.add(constantsClasses_1.CLASS_STICKY);
    };
    /**
     * Check if Footer is in Viewport document Scroll
     */
    CDFrame.prototype.documentScroll = function () {
        var _this = this;
        document.addEventListener('scroll', function () {
            var elementTop = _this.footer.getBoundingClientRect().top;
            if (elementTop <= _this.windowHeight) {
                _this.cdFrame.classList.add(constantsClasses_1.CLASS_STICKY);
                FloatingCTA_1.default.floatingCTA.classList.add(constantsClasses_1.CLASS_STICKY);
                StickyHeader_1.default.header.classList.add(constantsClasses_1.CLASS_TOP_0);
                return;
            }
            _this.cdFrame.classList.remove(constantsClasses_1.CLASS_STICKY);
            FloatingCTA_1.default.floatingCTA.classList.remove(constantsClasses_1.CLASS_STICKY);
            StickyHeader_1.default.header.classList.remove(constantsClasses_1.CLASS_TOP_0);
        });
    };
    /**
     * Adjusting height of CdFrame if window height changes. For example the dissappearing browser-nav in safari on mobile devices when scrolling down.
     */
    CDFrame.prototype.handleWindowHeightResize = function () {
        var _this = this;
        var windowHeightResizeHandler = function () {
            _this.cdFrame.style.height = "".concat(window.innerHeight, "px");
        };
        window.addEventListener('resize', windowHeightResizeHandler);
    };
    return CDFrame;
}(AbstractComponent_1.default));
exports.default = CDFrame;
